import { render } from "./TitleDivider.vue?vue&type=template&id=8eb8805a&scoped=true&ts=true"
import script from "./TitleDivider.vue?vue&type=script&lang=ts"
export * from "./TitleDivider.vue?vue&type=script&lang=ts"

import "./TitleDivider.vue?vue&type=style&index=0&id=8eb8805a&lang=scss&scoped=true"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eb8805a"]])

export default __exports__